import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 * 404 page — no AdSense units (policy: no ads on screens without publisher content).
 */
const NotFound = () => {
  const history = useHistory();

  return (
    <div className="container section-padding text-center" style={{ minHeight: '50vh' }}>
      <h1 className="gradient-text" style={{ fontSize: '48px', marginBottom: '16px' }}>
        Page not found
      </h1>
      <p style={{ fontSize: '16px', marginBottom: '24px' }}>
        The page you are looking for does not exist or has been moved.
      </p>
      <button
        className="btn btn-dark"
        type="button"
        onClick={() => history.push('/')}
      >
        Go to Home
      </button>
    </div>
  );
};

export default NotFound;
